module.exports = __webpack_public_path__ + "media/images/no-records-cfb49f55eb8da55ee5e66a7587b12849.svg";